/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Geosuppressednote2Inputs */

const en_geosuppressednote2 = /** @type {(inputs: Geosuppressednote2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} areas hidden: too few people to show without identifying them.`)
};

const de_geosuppressednote2 = /** @type {(inputs: Geosuppressednote2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Gebiete verborgen: zu wenige Personen, um sie ohne Identifizierung zu zeigen.`)
};

/**
* | output |
* | --- |
* | "{count} areas hidden: too few people to show without identifying them." |
*
* @param {Geosuppressednote2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const geosuppressednote2 = /** @type {((inputs: Geosuppressednote2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geosuppressednote2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geosuppressednote2(inputs)
	return de_geosuppressednote2(inputs)
});
export { geosuppressednote2 as "geoSuppressedNote" }